import { IScripDetails } from "../types/naming-card-type.types";
import { API_PATHS } from "../constants/api-paths";
// Stub: IOverviewInfo mirrors TypeSharesStore – update import once store types are migrated.
// import { IOverviewInfo } from "../store/TypeSharesStore";
type IOverviewInfo = Record<string, unknown>;
import { request } from "../core/api.client";
const timeStamp = Date.now();
export const getScripOverviewInfo = async (exchId: string, formattedSymbol: string) => {
  const response = await request<IOverviewInfo>({
    method: "GET",
    url: `${API_PATHS.scripOverviewInfo}?exchId=${exchId}&formattedSymbol=${formattedSymbol}`,
  });
  return response;
};
export const getScripDetails = async (exchId: string, formattedSymbol: string) => {
  const response: IScripDetails = await request({
    method: "GET",
    url: `${API_PATHS.scripDetails}?exchId=${exchId}&formattedSymbol=${formattedSymbol}&timeStamp=${timeStamp}`,
  });
  return response;
};
